import {FormEvent, useState} from 'react';
import {Knowledge, KnowledgeForm, KnowledgeMode, UploadProgress} from '../types';
import {knowledgeForm, saveKnowledge} from '../services/knowledge';
import {errorMessage} from '../errors';
import {toast} from '../components/ui/sonner';

export function useKnowledgeEditor(onSaved: (document: Knowledge) => void) {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState<Knowledge | null>(null);
  const [form, setForm] = useState<KnowledgeForm>(() => knowledgeForm(null));
  const [mode, setMode] = useState<KnowledgeMode>('text');
  const [file, setFile] = useState<File | null>(null);
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const [progress, setProgress] = useState<UploadProgress | null>(null);

  function start(document: Knowledge | null = null): void {
    setEditing(document); setForm(knowledgeForm(document)); setMode('text'); setError(''); setFile(null); setProgress(null); setOpen(true);
  }
  function change(patch: Partial<KnowledgeForm>): void { setForm(previous => ({...previous, ...patch})); }
  function changeOpen(value: boolean): void { if (!busy) setOpen(value); }
  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault(); setBusy(true); setError(''); setProgress(null);
    try {
      const document = await saveKnowledge({mode, form, file, editing, onProgress: setProgress});
      onSaved(document); setOpen(false);
      toast.success(editing ? 'Article updated' : 'Knowledge added');
    } catch (failure: unknown) { setError(errorMessage(failure)); }
    finally { setBusy(false); setProgress(null); }
  }
  return {open, editing, form, mode, setMode, setFile, busy, error, progress, start, change, changeOpen, submit};
}
export type KnowledgeEditorController = ReturnType<typeof useKnowledgeEditor>;